export default {
    password: {
        layout: {
            default: [
                "1 2 3 4 5 6 7 8 9 0 -",
                "q w e r t y u i o p {bksp}",
                "a s d f g h j k l",
                "{shift} z x c v b n m . {close}",
            ],
            shift: [
                "! @ # $ * ? _",
                "Q W E R T Y U I O P {bksp}",
                "A S D F G H J K L",
                "{shift} Z X C V B N M .",
                "{close}"
            ],
        },
        display: {
            "{close}": "❌", //https://en.wikipedia.org/wiki/X_mark
            "{bksp}": "⌫",
            "{shift}": "⇧",
        }
    },

    login: {
        layout: {
            default: [
                "1 2 3 4 5 6 7 8 9 0 -",
                "q w e r t y u i o p {bksp}",
                "a s d f g h j k l _",
                "z x c v b n m . {close}",
            ]
        },
        display: {
            "{close}": "❌",
            "{bksp}": "⌫",
        }
    },

    number: {
        layout: {
            default: [
                "1 2 3", 
                "4 5 6", 
                "7 8 9", 
                "{bksp} 0 {close}", 
            ],
        },
        display: {
            "{close}": "❌",
            "{clear}": "⎚",
            "{bksp}": "⌫", //← ⇦ ⊲
        }
    },

    normal: {
        layout: {
            default: [
                "Q W E R T Y U I O P {bksp}",
                "A S D F G H J K L Ç",
                "{shift} Z X C V B N M , . {shift}",
                "{alt} {space} {alt} {close}"
            ],
            shift: [
                "q w e r t y u i o p {bksp}",
                "a s d f g h j k l ç",
                "{shift} z x c v b n m , . {shift}",
                "{alt} {space} {alt} {close}"
            ],
            alt: [
                "1 2 3 4 5 6 7 8 9 0 {bksp}",
                `@ # $ & * ( ) ' "`,
                "{shift} % - + = / ; : ! ? {shift}",
                "{alt} {space} {alt} {close}"
            ]
          },
          display: {
            "{alt}": ".?123",
            "{smileys}": "\uD83D\uDE03",
            "{shift}": "⇧",
            "{shiftactivated}": "⇧",
            "{enter}": "return",
            "{bksp}": "⌫",
            "{altright}": ".?123",
            "{downkeyboard}": "🞃",
            "{space}": " ",
            "{default}": "ABC",
            "{back}": "⇦",
            "{close}": "✔",
          }
    }
}